export const logintext={
    enter:'ورود / ثبت نام',
    signup: "ثبت نام",
    exit:'خروج از حساب کاربری',
    user:'حساب کاربری',
    newshop:'ثبت فروشگاه',
    shop:'حساب فروشگاه',
    admin:' تنظیمات',
    create:'ثبت نام | ورود',
    waiting:'دریافت کد تایید',
    codebtn:'ثبت کد تایید',
    sendcode:'ارسال کد تایید',
    sendedcode:'کد تایید ارسال شد',
    resendtext:'ارسال مجدد کد تا 120 ثانیه دیگر',
    resend:'ارسال مجدد کد',
    entercode:'لطفا کد تایید را وارد کنید',
    enterPhone:'شماره موبایل خود راوارد نمایید( ...09 )  ',
    enterPodName:'نام کاربری حساب پاد خود را به اختیار وارد نمایید(به لاتین)',
    enterEmail:'ایمیل خود را وارد نمایید ',
    warnningAccept:'لطفا قوانین را مطالعه و قبول کنید',
    warnning:'شماره موبایل اشتباه می‌باشد',
    wrongcode:'کد وارد شده اشتباه است',
    continue:'ادامه',
    // user:'ورود به صفحه کاربری',
    experience:'برای تجربه بهتر لطفا وارد حساب کاربری شوید'
}